module.exports = __webpack_public_path__ + "static/media/new_work.82cd3d87.png";